import {html} from 'lit';
import {customElement, property, state} from 'lit/decorators.js';
import defaultStyle from '../b2b-public-styles.scss';
import B2bElement from '../../b2b-element.js';
import B2bPublicServiceClientProxy from '../../gen/com/arabellesolutions/sdc/b2b/pub/B2bPublicServiceClientProxy.js';
import {map} from 'lit/directives/map.js';
import ExternalUser from "../../gen/com/arabellesolutions/sdc/b2b/common/user/ExternalUser.js";
import {when} from "lit/directives/when.js";

@customElement('b2b-public-home')
export class B2bPublicHome extends B2bElement {
  static styles = [defaultStyle];

  /** @type {ExternalUser} */
  @property({type: ExternalUser, attribute: false})
  accessor user;

  @state()
  accessor __userNotFound;

  @state()
  accessor __applications;

  __b2bPublicServiceProxy = new B2bPublicServiceClientProxy(super.msgpackClientPublic());

  render() {
    if (!this.user) {
      return html`<h1>Loading</h1>`;
    }
    this.__applications = this.getUniqueApplications();

    return html`
        <mta-page-title page-name="home" title="Home"></mta-page-title>

        <mta-header hide-menu>
            <div slot="full-left" class="full-left">
                <common-mta-logo class="logo" url=""></common-mta-logo>
                <a href="">B2B</a>
            </div>
            <div slot="full-middle" class="full-middle">
                Dashboard
            </div>
            <div slot="full-right" class="full-right">
                <mta-icon icon="logout" label="Sign Out" @click="${this.logout}"></mta-icon>
            </div>
        </mta-header>
        ${when(this.__applications.length === 0, () => html`
            <section class="app-selection">
                <h2>You don't have any application yet, please contact your Power User / MTA support team to get assigned to one.</h2>
            </section>
        `, () => html`
            <section class="app-selection">
                <h2>Choose the application you want to access</h2>
                <p>Click one of the applications below to continue to sign in.</p>
                <div class="app-grid">
                    ${map(this.__applications, application => html`
                    <mta-datacard-light class="app-card" as-button no-highlight text-content="${application.name}"
                                        card-title="${application.description}"
                                        @click="${() => this.fetchUsernames(application)}"></mta-datacard-light>
                `)}
                </div>
            </section>
        `)}
    `;
  }

  fetchUsernames(app) {
    window.location.href = `#/sso/ssoSelection/code=${app.id}`;
    window.location.reload();
  }

  getUniqueApplications() {
    const grantedAccesses = this.user.applicationAccesses.filter(access => access.accessGranted);
    const uniqueAppsMap = new Map();

    grantedAccesses.forEach(access => {
      const appId = access.idApp;
      if (!uniqueAppsMap.has(appId)) {
        uniqueAppsMap.set(appId, access.app);
      }
    });
    return Array.from(uniqueAppsMap.values());
  }

  logout() {
    window.location.href = '#/auth/logout';
  }
}
